import { render, staticRenderFns } from "./SpecialCategory.vue?vue&type=template&id=57a660a0&"
import script from "./SpecialCategory.vue?vue&type=script&lang=js&"
export * from "./SpecialCategory.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports